export const ThankYouButton = 'トップページへ'
export const PamphletPageNumber = 'EBHP3168'
